<template lang="pug">
  .details-wrapper
    .nome
      DBLabel(title="nome da regra:", :body="rule.name")
    //- .codigo
    //-   DBLabel(title="código:", :body="rule.code")
    //- .inicio
    //-   DBLabel(title="início da vigência:", :body="rule.startDate")
    //- .fim
    //-   DBLabel(title="fim da vigência:", :body="rule.endDate")
    .status
      DBLabel(title="status:", :body="rule.active ? 'ativo' : 'inativo'")
    .tipo-evento
      DBLabel(title="tipo de evento:", :body="parseEvent(rule)")
    .gerado
      DBLabel(title="quando é gerado:", :body="parseDescricaoGeramento(rule)")
    .gerador
      template(v-if="rule.companys && rule.companys.length > 0")
        PMultiSelect(
          v-model="companies"
          useCommon="companies"
          labelItem="name"
          :title="$ws('company')"
          displayMode
        )
      template(v-if="rule.groups && rule.groups.length > 0")
        PMultiSelect(
          v-model="groups"
          useCommon="userGroups"
          labelItem="name"
          title="grupo"
          displayMode
        )
      template(v-if="rule.employees && rule.employees.length > 0")
        PMultiSelect(
          v-model="employees"
          useCommon="employees"
          labelItem="name"
          :title="$wp('employee')"
          displayMode
        )
      template(v-if="rule.perfis && rule.perfis.length > 0")
        PMultiSelect(
          v-model="perfis"
          useCommon="roleGroups"
          labelItem="name"
          title="perfis"
          displayMode
        )

    template(v-if="rule.modelToCreate === 'AbstractJustify'")
      .descricao-evento-1
        PMultiSelect(
          v-model="reasons"
          useCommon="reasons"
          labelItem="name"
          title="motivos"
          displayMode
        )
      .descricao-evento-2
        DBLabel(
          title="prazo para bloqueio:"
          :body="mensagemDeLimiteDeDias"
        )

    template(v-if="rule.modelToCreate === 'Line'")
      .limits-regra-de-calculo(v-if="rule.customRules")
        .title regra de cálculo:
        b.nome-da-regra {{ rule.customRules.name }}
      .limits-listados
        .title eventos:
        b.evento-limits(v-for="(item, index) in rule.limits") {{ parseRegraDeApontamento(item, rule) }}

    template(v-if="rule.modelToCreate === 'FakeTimeLog'")
      .descricao-evento
        DBLabel(
          title="prazo para bloqueio:"
          :body="mensagemDeLimiteDeDias"
        )

    template(v-if="!rule.autoApprove")
      .quem-responde
        .title quem responde:
        b.nome-do-perfil(v-for="perfil in rule.limiteAprovacoesMensalPorPerfil") {{ perfil.name_perfil }}
      .limite-mensal-por-usuario-do-perfil
        .title limite mensal por usuário do perfil:
        b.limite(v-for="perfil in rule.limiteAprovacoesMensalPorPerfil")
          | {{ perfil.limite_aprovacoes_mensal_por_perfil === 0 ? 'ilimitado' : perfil.limite_aprovacoes_mensal_por_perfil}}

    .checkbox
      PCheckbox(label="aprovar pedidos da regra automaticamente (poderá ser respondido com ciência do pedido)" v-model="rule.autoApprove", readonly)
      PCheckbox(v-if="rule.createFirst" label="registrar e calcular eventos na folha antes da resposta (será deletado em caso de reprovação)" v-model="rule.createFirst", readonly)

    .botoes-de-acao
      PButton(
        color="info"
        size="md"
        @click="editarRegra(rule)"
        title="editar"
        :disabled="carregandoAtualizacaoRegra || removerCarregando"
      )
        .icon-ptt-icons-lapis
      PButton(
        color="warning"
        size="md"
        @click="atualizarAtivacaoRegra(rule)"
        :loading="carregandoAtualizacaoRegra"
        :disabled="removerCarregando"
        :title="operacaoPermitida + ' regra'"
      )
        span {{ operacaoPermitida }} regra
      PConfirmButton(
        text="Excluir regra de aprovação?"
        color="danger"
        size="md"
        @click="deletarRegra(rule)"
        :loading="removerCarregando"
        :disabled="carregandoAtualizacaoRegra"
        title="excluir"
      )
        .icon-ptt-icons-excluir

</template>

<script>
import { camelCase, pick } from 'lodash'

export default {
  name: 'ApprovalsRulesDetails',
  props: {
    rule: {type: Object, required: true}
  },
  data () {
    return {
      removerCarregando: false,
      carregandoAtualizacaoRegra: false
    }
  },
  computed: {
    mensagemDeLimiteDeDias () {
      const { limiteDeDiasPermitido } = this.rule
      if (!limiteDeDiasPermitido || limiteDeDiasPermitido === 0) return '-'

      return `${limiteDeDiasPermitido} dias após a data do evento`
    },
    operacaoPermitida () {
      return this.rule.active
        ? 'desativar'
        : 'reativar'
    },
    companies: {
      set (val) {},
      get () { return {selected: this.rule.companys} }
    },
    groups: {
      set (val) {},
      get () { return {selected: this.rule.groups} }
    },
    employers: {
      set (val) {},
      get () { return {selected: this.rule.employers} }
    },
    perfis: {
      set (val) {},
      get () { return {selected: this.rule.perfis} }
    },
    reasons: {
      set (val) {},
      get () { return {selected: this.rule.reasons} }
    },
    employees: {
      set (val) {},
      get () { return {selected: this.rule.employees} }
    }
  },
  methods: {
    async deletarRegra (rule) {
      this.removerCarregando = true
      try {
        await this.$API.approvalsRules.delete({}, {id: rule.id})
        this.$modalDeSucesso('Regra deletada com sucesso!')
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível excluir regra.')
      } finally {
        this.removerCarregando = false
        this.$emit('reloadTable')
      }
    },
    async atualizarAtivacaoRegra (rule) {
      console.log('ativar/desativar regra')
      const novoEstado = !rule.active
      const parametros = {
        ...pick(rule, ['id', 'name', 'modelToCreate', 'createFirst', 'autoApprove', 'limits']),
        active: novoEstado
      }

      this.carregandoAtualizacaoRegra = true
      try {
        if (rule.modelToCreate === 'Line') {
          await this.$API.lineApprovalRules.save(parametros)
        } else {
          await this.$API.objectsApprovalRules.save(parametros)
        }
        this.$modalDeSucesso(`Regra ${rule.active ? 'desativada' : 'ativada'} com sucesso!`)
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : `Não foi possível ${rule.active ? 'desativar' : 'ativar'} regra.`)
      } finally {
        this.carregandoAtualizacaoRegra = false
        this.$emit('reloadTable')
      }
    },
    editarRegra (rule) {
      this.$router.push(`/approvals-rules/${rule.id}`)
    },
    parseEvent (item) {
      const EVENT_CONVERTER = {
        'Line': 'apontamento',
        'FakeTimeLog': 'correção de ponto',
        'AbstractJustify': 'dispensa',
        'DayJourney': 'conversão de falta em bh'
      }
      return (EVENT_CONVERTER[item.modelToCreate])
    },
    parseRegraDeApontamento (item, rule) {
      const itemName = camelCase('show_' + item.name.replace('_tot', ''))

      if (['00:00', null].includes(item.min) && item.max) {
        return rule.titles[itemName]['text'] + ' menor ou igual a ' + item.max + ' hora(s)'
      } else if ((['00:00', null].includes(item.max) && item.min)) {
        return rule.titles[itemName]['text'] + ' maior ou igual a ' + item.min + ' hora(s)'
      } else {
        return rule.titles[itemName]['text'] + ' maior ou igual a ' + item.min + ' hora(s) e menor ou igual a ' + item.max + ' hora(s)'
      }
    },
    parseDescricaoGeramento (regra) {
      const { employees, companys, groups, perfis } = regra

      if (employees.length > 0) {
        if (employees.length === 1) return `lançado para ${this.$ws('employee')} ${employees[0].name}`
        return `lançado para algum de ${employees.length} ${this.$wp('employee')}`
      } else if (companys.length > 0) {
        if (companys.length === 1) return `lançado para ${this.$ws('company')} ${companys[0].name}`
        return `lançado para algum de ${companys.length} ${this.$wp('company')}`
      } else if (groups.length > 0) {
        if (groups.length === 1) return `lançado para ${this.$ws('group')} ${groups[0].name}`
        return `lançado para algum de ${groups.length} ${this.$wp('group')}`
      } else if (perfis.length > 0) {
        if (perfis.length === 1) return `lançado pelo perfil ${perfis[0].name}`
        return `lançado por algum de ${perfis.length} perfis`
      }
    }
  }
}
</script>

<style scoped lang="scss">
.details-wrapper {
  overflow-y: auto;

  text-transform: lowercase;
  font-family: 'Rubik';

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-gap: 10px;

  .nome { grid-column: 1/3; }

  .status { grid-column: 3/4; }

  .tipo-evento { grid-column: 1/2; }

  .gerado { grid-column: 2/3; }

  .gerador { grid-column: 3/4; }

  .descricao-evento { grid-column: 1/5; }

  .descricao-evento-1 { grid-column: 1/2; width: 250px;}

  .descricao-evento-2 { grid-column: 2/5; overflow-wrap: normal; }

  .checkbox { grid-column: 1/5; }

  .nome-do-perfil, .limite, .nome-da-regra, .limits-listados {
    font-size: 19px;
    color: var(--color-primary);
    display: block;
  }

  .quem-responde, .limite-mensal-por-usuario-do-perfil, .limits-regra-de-calculo, .limits-listados {
    .title {
      display: block;
      font-size: 15px;
    }
  }

  .limits-regra-de-calculo {
    grid-column: 1/2;
  }

  .limite-mensal-por-usuario-do-perfil, .limits-listados {
    grid-column: 2/5;
  }

  .span-default {
    margin-top: 10px;
    font-size: 19px;
    font-weight: bold;
    color: var(--color-primary);
  }

  .botoes-de-acao {
    grid-column: 1/5;
    justify-self: right;
    align-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-gap: 1px;
  }

}
</style>
